import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import get from 'lodash/get';
import { createPhoneLink } from '../../../../utils/utility';
import Link from '../../../components/atoms/Link';
import Grid from '../../../components/molecules/Grid';
import Typography from '../../../components/atoms/Typography';
import useStyles from './style';
import { analyticsData } from '../../../../constants/Analytics/analytics-data';
import { createDynamicLabels } from '../../../../utils/analytics';

const TabContent = props => {
  const { pageName, componentName } = props;
  const countriesList = (props && props.countriesList) || '';
  const classes = useStyles();
  return countriesList && countriesList.length > 0 ? (
    <Grid container className={classes.tabContent}>
      {countriesList.map((country, index) => {
        const { fields } = country;
        const { title, address, phoneNumber, email, website } = fields || '';
        return (
          <Grid
            item
            lg={4}
            xs={12}
            className="countrySection"
            key={`${title && title.value}_${index}`}
          >
            {title && title.value && (
              <Typography
                variant="h5"
                component="h3"
                gutterBottom={true}
                className="heading"
              >
                <Text field={title} />
              </Typography>
            )}
            {address && address.value && (
              <Typography variant="body1" component="pre">
                <Text field={address} />
              </Typography>
            )}
            {website && website.value && (
              <Link
                data-id={analyticsData.dataIds.pageBodyNavLinkClick}
                data-link={createDynamicLabels([
                  pageName,
                  componentName,
                  analyticsData.dataLinksText.contactByEmail,
                ])}
                target={get(website, 'value.target', '')}
                isCustom={true}
                isExternalLink={true}
                customHref={get(website, 'value.href', '')}
                className="link-text"
              >
                <Typography variant="body1Bold" component="span">
                  <Text field={{ value: get(website, 'value.text', '') }} />
                </Typography>
              </Link>
            )}
            {phoneNumber && phoneNumber.value && (
              <Link
                data-id={get(analyticsData, 'dataIds.pageBodyNavLinkClick')}
                data-link={createDynamicLabels([
                  pageName,
                  componentName,
                  get(analyticsData, 'dataLinksText.contactByPhone'),
                ])}
                isCustom={true}
                customHref={createPhoneLink(phoneNumber.value)}
                className="no-flip link-text"
              >
                <Typography
                  variant="body1Bold"
                  component="span"
                  className="no-flip"
                >
                  <Text field={phoneNumber} />
                </Typography>
              </Link>
            )}
            {email && email.value && email.value.text && (
              <Link
                data-id={analyticsData.dataIds.pageBodyNavLinkClick}
                data-link={createDynamicLabels([
                  pageName,
                  componentName,
                  analyticsData.dataLinksText.contactByEmail,
                ])}
                isCustom={true}
                customHref={get(email, 'value.href', '')}
                className="link-text"
              >
                <Typography variant="body1Bold" component="span">
                  <Text field={{ value: get(email, 'value.text', '') }} />
                </Typography>
              </Link>
            )}
          </Grid>
        );
      })}
    </Grid>
  ) : null;
};

export default TabContent;
